import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from '../utils/api';
import config from '../config';

const defaults = {
  companyName: config.companyName,
  productName: config.productName,
  productShortName: config.productShortName,
  supportEmail: config.supportEmail,
  copyright: config.copyright || `© ${new Date().getFullYear()} ${config.companyName}. All rights reserved.`,
  primaryColor: config.primaryColor,
  loaded: false,
};

const BrandContext = createContext(defaults);

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(defaults);

  useEffect(() => {
    const applyColor = (color) => {
      if (!color) return;
      const root = document.documentElement;
      root.style.setProperty('--primary-500', color);
      root.style.setProperty('--primary-600', color);
      root.style.setProperty('--primary-700', color);
    };

    applyColor(config.primaryColor);

    axios.get('/auth/branding/')
      .then((res) => {
        const d = res.data || {};
        const next = {
          companyName: d.company_name || config.companyName,
          productName: d.product_name || config.productName,
          productShortName: d.product_short_name || config.productShortName,
          supportEmail: d.support_email || config.supportEmail,
          copyright: d.copyright || defaults.copyright,
          primaryColor: d.primary_color || config.primaryColor,
          loaded: true,
        };
        setBrand(next);
        document.title = next.productName;
        applyColor(next.primaryColor);
      })
      .catch(() => {
        setBrand((prev) => ({ ...prev, loaded: true }));
        document.title = config.productName;
      });
  }, []);

  return (
    <BrandContext.Provider value={brand}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  return useContext(BrandContext);
}
